import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError, LOGO_URL } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [link, setLink] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg("If an account exists for that email, a reset link has been sent.");
      if (data.reset_link) setLink(data.reset_link);
    } catch (err) {
      setMsg(formatApiError(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-blue-800 dark:bg-slate-950 flex flex-col" style={{ fontFamily: "'IBM Plex Sans', system-ui, sans-serif" }}>
      <div className="p-4"><Link to="/"><img src={LOGO_URL} alt="logo" className="h-12" /></Link></div>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-3xl shadow-2xl p-8 border border-slate-200 dark:border-slate-800">
          <h1 className="text-2xl font-black text-slate-900 dark:text-white mb-1" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Reset password</h1>
          <p className="text-slate-500 dark:text-slate-400 text-sm mb-6">Enter your email and we'll send you a reset link.</p>
          <form onSubmit={onSubmit} className="space-y-4">
            <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 px-4 py-3 outline-none focus:border-blue-500 text-slate-900 dark:text-slate-100" />
            <button data-testid="forgot-submit-btn" disabled={busy} className="w-full rounded-full bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 disabled:opacity-60 transition-colors duration-200">Send reset link</button>
          </form>
          {msg && <div className="mt-4 text-sm text-slate-700 dark:text-slate-300" data-testid="forgot-msg">{msg}</div>}
          {link && <div className="mt-2 text-xs text-slate-500 break-all" data-testid="forgot-devlink">Dev link: <a className="underline" href={link}>{link}</a></div>}
          <div className="mt-4 text-sm"><Link to="/login" className="text-blue-700 dark:text-blue-400 hover:underline">Back to sign in</Link></div>
        </div>
      </div>
    </div>
  );
}
